"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'cart_bar',
  cname: '购物车',
  // 标题名称
  icon: 't-icon-zujian-dibucaidan',
  configName: 'c_cart_bar',
  // 右侧配置名称
  type: 0,
  // 0 基础组件 1 营销组件 2 工具组件
  defaultName: 'cartBar',
  // 外面匹配名称
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, (0, _vuex.mapState)('mobildConfig', ['defaultArray'])), (0, _vuex.mapGetters)(['mobileTheme'])), {}, {
    // 结算栏背景渐变
    barStyle: function barStyle() {
      var color = this.configObj.bgColor.color;
      return {
        background: "linear-gradient(180deg, ".concat(color[0].item, ", ").concat(color[1].item, ")")
      };
    },
    // 合计金额颜色
    priceStyle: function priceStyle() {
      return {
        color: this.configObj.priceColor.color[0].item
      };
    },
    // 优惠文字颜色
    discountStyle: function discountStyle() {
      return {
        color: this.configObj.discountColor.color[0].item
      };
    },
    // 去结算按钮样式
    btnStyle: function btnStyle() {
      var color = this.configObj.btnColor.color;
      return {
        background: "linear-gradient(90deg, ".concat(color[0].item, ", ").concat(color[1].item, ")"),
        color: this.configObj.btnTextColor.color[0].item,
        'border-radius': this.configObj.contentStyle.val + 'px'
      };
    }
  }),
  watch: {
    pageData: {
      handler: function handler(nVal) {
        this.setConfig(nVal);
      },
      deep: true
    },
    num: {
      handler: function handler(nVal) {
        var data = this.$store.state.mobildConfig.defaultArray[nVal];
        this.setConfig(data);
      },
      deep: true
    },
    defaultArray: {
      handler: function handler() {
        var data = this.$store.state.mobildConfig.defaultArray[this.num];
        this.setConfig(data);
      },
      deep: true
    }
  },
  data: function data() {
    return {
      // 默认初始化数据禁止修改
      defaultConfig: {
        isHide: false,
        name: 'cartBar',
        timestamp: this.num,
        setUp: {
          tabVal: 0,
          cname: '购物车'
        },
        // 购物车图标
        cartIcon: {
          isShow: 1,
          tabTitle: '购物车图标',
          title: '购物车图标',
          tips: '建议上传大小：宽50px，高50px',
          header: '购物车图标',
          url: ''
        },
        // 按钮文字
        btnConfig: {
          isShow: 1,
          title: '按钮文字',
          val: '去结算',
          place: '请输入按钮文字',
          max: 6
        },
        // 显示优惠金额
        discountShow: {
          title: '显示优惠金额',
          val: true
        },
        // 背景渐变色
        bgColor: {
          tabTitle: '颜色设置',
          title: '背景颜色',
          color: [{
            item: '#F7F7F7'
          }, {
            item: '#F7F7F7'
          }],
          default: [{
            item: '#F7F7F7'
          }, {
            item: '#F7F7F7'
          }]
        },
        // 合计金额颜色
        priceColor: {
          title: '金额颜色',
          color: [{
            item: '#E93323'
          }],
          default: [{
            item: '#E93323'
          }]
        },
        // 优惠文字颜色
        discountColor: {
          title: '优惠文字颜色',
          color: [{
            item: '#FF9601'
          }],
          default: [{
            item: '#FF9601'
          }]
        },
        // 按钮背景渐变
        btnColor: {
          title: '按钮背景',
          color: [{
            item: '#47C043'
          }, {
            item: '#47C043'
          }],
          default: [{
            item: '#47C043'
          }, {
            item: '#47C043'
          }]
        },
        // 按钮文字颜色
        btnTextColor: {
          title: '按钮文字颜色',
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        // 按钮圆角
        contentStyle: {
          title: '按钮圆角',
          name: 'contentStyle',
          val: 20,
          min: 0,
          max: 25
        }
      },
      pageData: {},
      configObj: null
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      if (_this.num) {
        _this.pageData = _this.$store.state.mobildConfig.defaultArray[_this.num];
        _this.setConfig(_this.pageData);
      }
    });
  },
  methods: {
    setConfig: function setConfig(data) {
      if (!data) return;
      this.configObj = data;
    }
  }
};